import { createFileRoute } from "@tanstack/react-router";
import { EditExpeditionPage } from "@/features/ventes/components/expeditions/EditExpeditionPage";

export const Route = createFileRoute("/_app/ventes/expeditions/$id/edit")({
  staticData: {
    title: "Modifier expédition",
    showInBreadcrumb: true,
  },
  component: EditExpeditionPage,
});
